import type { EntityValidationRules } from "services/validationService";
import { Type } from "class-transformer";
import { observable } from "mobx";
import VehicleRequest from "./licensePlate";
import { addDays, subDays } from "date-fns";
import { endOfCzechDay } from "utils/dateUtils";

export default class CreateExemptionRequest {
  /**
   * Official record ID.
   */
  @observable
  officialRecordId!: string;
  /**
   * Official record ID.
   */
  @observable
  _officialRecordId!: string;

  /**
   * Exemption reason ID.
   */
  @observable
  exemptionReasonId!: string;

  @observable
  @Type(() => VehicleRequest)
  vehicle!: VehicleRequest;

  /**
   * Exemption is valid since this date.
   */
  @observable
  @Type(() => Date)
  validSinceDate!: Date;

  /**
   * If specified, exemption is valid until this date (last second of the date).
   */
  @observable
  @Type(() => Date)
  validUntilDate?: Date;
}

export const CreateExemptionValidationRules: EntityValidationRules<CreateExemptionRequest> = {
  exemptionReasonId: {
    required: true,
  },
  validSinceDate: {
    required: true,
    isAfter: {
      condition: (entity: CreateExemptionRequest) => endOfCzechDay(addDays(new Date(), -1)),
    },
  },
  validUntilDate: {
    isAfter: {
      condition: (entity: CreateExemptionRequest) => endOfCzechDay(subDays(entity.validSinceDate, 1)),
    },
  },
  officialRecordId: {
    required: true,
    isLength: {
      min: 3,
      max: 50,
    },
  },
};
